export default __webpack_public_path__ + "static/chantal-monsma-7dcdd8bb59cf0a7128bd28a42bdf5479.png";